<ion-button class="button" [color]="color" [size]="size" [fill]="fill" [disabled]="disabled" [type]="type" (click)="clicked.emit()">
  <ng-content></ng-content>
</ion-button>